import React from 'react';
import clsx from 'clsx';

interface OpportunityPhaseCardProps {
  title?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}

const OpportunityPhaseCard: React.FC<OpportunityPhaseCardProps> = ({
                                                                     title,
                                                                     actions,
                                                                     children,
                                                                     className,
                                                                     bodyClassName,
                                                                   }) => {
  return (
    <div className={clsx('rounded-lg border border-gray-200 bg-white', className)}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3">
          <div className="font-medium">{title}</div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={clsx('p-4', bodyClassName)}>
        {children}
      </div>
    </div>
  );
};

export default OpportunityPhaseCard;